export const FAQ_STRINGS = {
  en: {
    TITLE: 'FAQ',
  },
  sv: {
    TITLE: 'Vanliga frågor',
  },
  nb: {
    TITLE: 'Vanlige spørsmål',
  },
  da: {
    TITLE: 'Ofte stillede spørgsmål',
  },
} as const
